import cn from 'classnames';
import { Formik, Form } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import Button from 'components/common/Button';
import FormField from 'components/common/FormField';
import { TEMPO } from 'context/BrandContext';
import { validateSvsCode } from 'helpers/vouchers';
import useBrand from 'hooks/useBrand';

const formatCode = code => code.replace(/\s/g, '');

const PromoCodeForm = ({
  handleAddVoucherClick,
  errorMessage = '',
  buttonVariation = 'TextPrimary',
  buttonClassName = '',
  buttonText = 'Apply',
  formFieldClassName,
}) => {
  const [showPin, setShowPin] = useState(false);
  const isTempo = useBrand(TEMPO);

  return (
    <Formik
      initialValues={{
        promoCode: '',
        pin: '',
      }}
      validationSchema={Yup.object({
        promoCode: Yup.string().required('Please enter a promo code.'),
      })}
      onSubmit={handleAddVoucherClick}
    >
      {({ errors, setFieldValue, isSubmitting }) => (
        <Form
          className={cn('relative flex w-full flex-col', {
            'pb-10': errorMessage || errors.promoCode,
          })}
        >
          <div className={cn('flex w-full', formFieldClassName)}>
            <FormField
              label="Promo Code or Gift Card"
              labelClass="sr-only"
              containerClass="w-full flex-1 min-w-0"
              inputClass={cn(
                'h-14 w-full rounded-l-2xl rounded-r-none border border-r-0 border-solid pl-4 textSm',
                {
                  'border-charcoal-60 bg-white-100': isTempo,
                  'border-cream-120 bg-white-100': !isTempo,
                }
              )}
              id="promoCode"
              name="promoCode"
              placeholder="Promo Code or Gift Card"
              onKeyUp={event => {
                const formattedValue = formatCode(event.target.value);
                setFieldValue('promoCode', formattedValue);
                validateSvsCode({ value: formattedValue, callbackFn: setShowPin });
              }}
              error={errorMessage || errors.promoCode}
            />
            <Button
              className={cn(
                'h-14 shrink-0 whitespace-nowrap rounded-l-none rounded-r-2xl border border-solid',
                buttonClassName,
                {
                  'border-charcoal-60 bg-white-100': isTempo,
                  'border-cream-120 bg-white-100': !isTempo,
                }
              )}
              type="submit"
              isSubmitting={isSubmitting}
              variation={buttonVariation}
            >
              {isSubmitting ? 'Saving...' : buttonText}
            </Button>
          </div>
          {showPin && (
            <FormField
              name="pin"
              label="Pin Number"
              inputClass="mt-6 w-60 bp2:w-96"
              labelClass="sr-only"
              placeholder="Enter Pin"
              maxLength={4}
            />
          )}
        </Form>
      )}
    </Formik>
  );
};

PromoCodeForm.propTypes = {
  errorMessage: PropTypes.string,
  handleAddVoucherClick: PropTypes.func.isRequired,
  buttonVariation: PropTypes.string,
  buttonClassName: PropTypes.string,
  formFieldClassName: PropTypes.string,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PromoCodeForm;
